/**
 * Application branding — the single place the app's name and logo are declared.
 *
 * `APP_NAME` is the application name the raw HTML design ships in its layout
 * shells' brand slot (`<a class="navbar-brand">CreativeStudioOS</a>` in
 * RawHTMLDesign/layouts/*.html). It is the project's real product name; the
 * `name` field in package.json is still the scaffold's template id
 * ("react-node-template") and is deliberately not used for display.
 *
 * `APP_LOGO_SRC` stays null: the design assets under RawHTMLDesign/ contain no
 * logo/brand image, so the brand slot renders the application name as text. Drop
 * a logo into src/assets/ and point this at it (per the handle-file-storage
 * skill, design-time images belong in the frontend assets folder) and every
 * layout picks it up — the `.header-logo` sizing rule from the shells is already
 * in place.
 */
export const APP_NAME = 'CreativeStudioOS';

export const APP_LOGO_SRC = null;

export const APP_LOGO_ALT = `${APP_NAME} logo`;
